import { useCallback, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router';

import { Brand } from '../brand';
import { CurrentSection } from '../current-section';
import { Menu } from '../menu';
import { MenuButton } from '../menu-button';
import { NavLinks } from '../nav-links';

import styles from './style.module.css';

// The one bar every screen starts with (C16). It is the same 64px bar on every
// size; what changes is how the sections are reached. A phone gets the current
// section's name and an icon button that opens a hidden menu; a desktop gets
// the same entries as inline links. Both are rendered and the stylesheets pick
// one, so the choice follows the viewport without any script measuring it.
//
// This component owns only whether the phone menu is open. It closes when the
// route changes, so following a link never leaves the menu covering the page
// it led to.
export function TopBar() {
  const [ open, setOpen ] = useState(false);
  const button = useRef(null);
  const { pathname } = useLocation();

  useEffect(function() {
    setOpen(false);
  }, [ pathname ]);

  const onClick = useCallback(function() {
    setOpen(function(current) {
      return current === false;
    });
  }, []);

  // Closing from inside the menu hands focus back to the button that opened
  // it, so a keyboard user is not dropped at the top of the document.
  const onClose = useCallback(function() {
    setOpen(false);
    button.current.focus();
  }, []);

  let menu = null;

  if (open === true) {
    menu = <Menu onClose={ onClose }/>;
  }

  return (
    <header className={ styles.bar }>
      <div className={ styles.inner }>
        <Brand size={ 40 }/>

        <CurrentSection/>

        <NavLinks/>

        <MenuButton ref={ button } open={ open } onClick={ onClick }/>
      </div>

      { menu }
    </header>
  );
}
